import React, { useState } from 'react'
import { Box, Container, Tabs, Tab } from '@mui/material'
import TiktokAnalytics from './TiktokAnalytics'
import TiktokAnalysis from './TiktokAnalysis'
import PageAgentButton from '../agent/components/PageAgentButton'
import PageAgentDrawer from '../agent/components/PageAgentDrawer'
import { useVoiceRegistration } from '../voice/useVoiceRegistration'
import { buildVoiceTools } from '../voice/buildVoiceTools'
import useRouter from '../hooks/useRouter'
import useAccount from '../hooks/useAccount'
import { useDisplayNames } from '../utils/displayNames'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tiktok-tabpanel-${index}`}
      aria-labelledby={`tiktok-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

const TiktokDashboard: React.FC = () => {
  const router = useRouter()
  const account = useAccount()
  const customer = router.params.customer || account.customer?.name || ''
  const job = router.params.job || account.job?.name || ''
  const [tabValue, setTabValue] = useState(0)
  // The page helper (Douglas plan T16).
  const [helperOpen, setHelperOpen] = useState(false)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  // Douglas reads this back aloud, so it carries display names rather than

  // the codes in the URL (#1347 item 1).

  const names = useDisplayNames(customer)


  useVoiceRegistration({
    pageKey: `tiktok-dashboard:${customer}:${job}`,
    pageContext: () => `TikTok dashboard for ${names.customer} / ${names.job(job)}.`,
    uiTools: buildVoiceTools({
      choices: [
        {
          name: 'switch_tiktok_view',
          label: 'the TikTok view',
          options: [{ value: 'analytics' }, { value: 'analysis' }],
          select: (v) => setTabValue(v === 'analytics' ? 0 : 1),
        },
      ],
    }),
  })

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Container maxWidth="xl" sx={{ display: 'flex', alignItems: 'center' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="TikTok dashboard tabs"
            sx={{ pt: 2 }}
          >
            <Tab label="Analytics" id="tiktok-tab-0" aria-controls="tiktok-tabpanel-0" />
            <Tab label="Analysis" id="tiktok-tab-1" aria-controls="tiktok-tabpanel-1" />
          </Tabs>
          <Box sx={{ ml: 'auto', pt: 2 }}>
            <PageAgentButton
              pageKey="tiktok-dashboard"
              customer={account.customer?.name || customer}
              open={helperOpen}
              onClick={() => setHelperOpen(o => !o)}
            />
          </Box>
        </Container>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <TiktokAnalytics />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <TiktokAnalysis />
      </TabPanel>

      <PageAgentDrawer
        pageKey="tiktok-dashboard"
        customer={account.customer?.name || customer}
        job={job}
        open={helperOpen}
        onClose={() => setHelperOpen(false)}
      />
    </Box>
  )
}

export default TiktokDashboard